<template>
  <div class="new-edit page">
    <management-page-back-arrow @buttonClick="$router.back()" />
    <div class="page-section" v-if="!isLoading">
      <v-layout
        v-if="!oneSectionOnly"
        row
        justify-space-between
        align-start
        wrap
        style="margin-bottom: 20px"
      >
        <v-flex xs12 md5 lg4>
          <v-layout column align-start class="page-header mb-2">
            <span class="page-title mb-2">{{ pageTitle }} </span>
            <div class="buttons">
              <view-page-button
                v-if="showEdit"
                @click="editItem"
                :label="$t('Edit')"
                icon="edit"
                :disabled="editDisabled"
              />

              <view-page-button
                v-if="showDelete"
                @click="deleteItem"
                :label="$t('Delete')"
                icon="delete"
                :disabled="deleteDisabled"
              />
            </div>
          </v-layout>

          <slot name="leftSideContent" />
        </v-flex>

        <v-divider v-if="divider" vertical />

        <v-flex xs12 md6 lg7>
          <div class="page-header">
            <slot name="rightSideHeader" />
          </div>
          <slot name="rightSideContent" />
        </v-flex>
      </v-layout>

      <v-layout v-else column style="margin-bottom: 20px">
        <v-layout class="page-header">
          <span class="page-title">{{ pageTitle }} </span>
        </v-layout>

        <slot name="wholeSection" />
      </v-layout>

      <div class="action-buttons" v-if="withButtons">
        <management-button
          v-if="toggleFieldButton && !isConsumable" 
          type="execute"
          :label="toggleButtonLabel"
          style="margin: 0 auto 0 0"
          @buttonClick="$emit('toggleField')"
        />

        <management-button
          type="cancel"
          :label="$t('Cancel')"
          @buttonClick="$router.back()"
        />

        <management-button
          type="execute"
          :label="submitButtonLabel"
          :disabled="submitButtonDisabled"
          :list-missing-fields="listMissingFields"
          @buttonClick="submit"
        />
      </div>
    </div>

    <slot name="dialogBox" />

    <loading :active.sync="isLoading" :is-full-page="false" color="accent" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import ManagementButton from "../../Management/ManagementButton";
import ManagementPageBackArrow from "../ManagementPageBackArrow";
import ViewPageButton from "../ViewPage/ViewPageButton";

export default {
  name: "NewEditPage",

  components: { Loading, ManagementButton, ManagementPageBackArrow, ViewPageButton},

  props: {

    isConsumable:{
      type: Boolean,
      default: false,
    },

    /**
     * Title of the New or Edit Page.
     */
    pageTitle: {
      type: String,
      required: true
    },

    /**
     * Label of the submit button
     */
    submitButtonLabel: {
      type: String,
      required: true
    },

    /**
     * If the submit button is disabled or not.
     */
    submitButtonDisabled: {
      type: Boolean,
      default: false
    },

    /**
     * If the content of the page is loading or not.
     */
    isLoading: {
      type: Boolean,
      default: false
    },

    /**
     * If the Cancel and Save buttons are to be shown or not.
     */
    withButtons: {
      type: Boolean,
      default: true
    },

    divider: {
      type: Boolean,
      default: true
    },

    oneSectionOnly: {
      type: Boolean,
      default: false
    },

    /**
     * List of missing fields for the user being able add
     */
    listMissingFields: {
      type: Array,
      default: () => []
    },

    toggleFieldButton: {
      type: Boolean,
      default: false
    },

    toggleButtonLabel: {
      type: String,
      required: false
    },

    /**
     * List of missing fields for the user being able add
     */
    listMissingFields: {
      type: Array,
      default: () => []
    },
    showEdit:{
      type: Boolean
    },
    showDelete:{
      type: Boolean
    },
    editDisabled:{
      type: Boolean
    },
    deleteDisabled:{
      type: Boolean
    }
  },

  methods: {
    /**
     * Emits an event to the parent for submitting the action
     */
    submit() {
      this.$emit("submit");
    },
    editItem(){
      this.$emit("edit");
    },
    deleteItem(){
      this.$emit("delete");
    }
  }
};
</script>

<style scoped>
.new-edit.page {
  padding: 0 40px 40px 40px;
  width: 100%;
}

.page-header {
  width: 100%;
  min-height: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/NewEditPage/NewEditPage.vue